module.exports = __webpack_public_path__ + "static/media/eek5.00520fa7.JPG";